export const ProductActionTypes = {
    FETCH_PRODUCT: '@@product/FETCH_PRODUCT',
    SET_PRODUCT: '@@product/SET_PRODUCT',
    TOGGLE_SIZEGUIDE: '@@product/TOGGLE_SIZEGUIDE',
};
export const UserInfoActionTypes = {
    /** @deprecated - don't use redux for this, just call api.getUserInfo() */
    FETCH_USERINFO: '@@userInfo/FETCH_USERINFO',
};
export const SearchActionTypes = {
    TOGGLE_SEARCH: '@@search/TOGGLE_SEARCH',
    RESET_SEARCH: '@@search/RESET_SEARCH',
    INPUT_SEARCH: '@@search/INPUT_SEARCH',
    QUERY_SEARCH: '@@search/QUERY_SEARCH',
    FETCH_SEARCH: '@@search/FETCH_SEARCH',
    UPDATE_SEARCH_REFINEMENT: '@@search/UPDATE_SEARCH_REFINEMENT',
    MENU_DATA: '@@search/MENU_DATA',
};
export const ListingActionTypes = {
    FETCH_LISTING: '@@listing/FETCH_LISTING',
    UPDATE_LISTING_REFINEMENT: '@@listing/UPDATE_LISTING_REFINEMENT',
    TOGGLE_LANDING_ANIMATION: '@@listing/TOGGLE_LANDING_ANIMATION',
};
export const MinicartActionTypes = {
    FETCH_MINICART_AFTER_UPDATE: '@@search/FETCH_MINICART_AFTER_UPDATE',
    FETCH_MINICART_AND_OPEN: '@@search/FETCH_MINICART_AND_OPEN',
    UPDATE_MINICART: '@@search/UPDATE_MINICART',
    CLOSE_MINICART: '@@search/CLOSE_MINICART',
    HOVERING_MINICART: '@@search/HOVERING_MINICART',
};
export const BagActionTypes = {
    FETCH_BAG: '@@bag/FETCH_BAG',
    SETMESSAGE: '@@bag/SETMESSAGE',
    REMOVE_PRODUCT_FROM_BAG: '@@bag/REMOVE_PRODUCT_FROM_BAG',
    INCREASE_QUANTITY: '@@bag/INCREASE_QUANTITY',
    DECREASE_QUANTITY: '@@bag/DECREASE_QUANTITY',
    ADD_PROMO_CODE: '@@bag/ADD_PROMO_CODE',
    PROMOCODE_REMOVE: '@@bag/PROMOCODE_REMOVE',
};
export const AccountActionTypes = {
    FETCH_PROFILE: '@@account/FETCH_PROFILE',
    UPDATE_PROFILE: '@@account/UPDATE_PROFILE',
    FETCH_ADDRESSES: '@@account/FETCH_ADDRESSES',
    FETCH_MODEL: '@@account/FETCH_MODEL',
    DELETE_ADDRESSES: '@@account/DELETE_ADDRESSES',
    FETCH_SAVEDCARDS: '@@account/FETCH_SAVEDCARDS',
    DELETE_SAVEDCARD: '@@account/DELETE_SAVEDCARD',
};
export const OrdersActionTypes = {
    FETCH_ORDERS: '@@orders/FETCH_ORDERS',
    FETCH_ORDERS_PAGED: '@@orders/FETCH_ORDERS_PAGED',
    FETCH_ORDERS_DETAIL: '@@orders/FETCH_ORDER_DETAIL',
    FETCH_RETURNS: '@@orders/FETCH_RETURNS',
    FETCH_RETURNS_PAGED: '@@orders/FETCH_RETURNS_PAGED',
    CLEAN_FORM_ERRORS: '@@orders/CLEAN_FORM_ERRORS',
    SET_ERROR: '@@orders/SET_ERRORS',
    UPDATE_RETURN: '@@orders/UPDATE_RETURN',
};
export const AftercareActionTypes = {
    FETCH_AFTERCARE: '@@orders/FETCH_AFTERCARE',
    UPDATE_AFTERCARE: '@@orders/UPDATE_AFTERCARE',
};
export const CheckoutActionTypes = {
    FETCH_CHECKOUTDATA: '@@checkout/FETCH_CHECKOUTDATA',
    FETCH_PBLCHECKOUTDATA: '@@checkout/FETCH_PBLCHECKOUTDATA',
    UPDATE_ORDER: '@@checkout/UPDATE_ORDER',
    UPDATE_EMAIL: '@@checkout/UPDATE_EMAIL',
    UPDATE_PAYMENTERROR: '@@checkout/UPDATE_PAYMENTERROR',
    UPDATE_SHIPPINGMETHODS: '@@checkout/UPDATE_SHIPPINGMETHODS',
    UPDATE_CUSTOMER: '@@checkout/UPDATE_CUSTOMER',
    FETCH_ADDRESSES: '@@checkout/FETCH_ADDRESSES',
    FETCH_PAYMENTMETHODS: '@@checkout/FETCH_PAYMENTMETHODS',
    FETCH_PICKUP: '@@checkout/FETCH_PICKUP',
    UPDATE_LOADING: '@@checkout/UPDATE_LOADING',
    UPDATE_SHIPPINGADDRESS: '@@checkout/UPDATE_SHIPPINGADDRESS',
    UPDATE_GIFTCARDS_APPLIED: '@@checkout/UPDATE_GIFTCARDS_APPLIED',
    UPDATE_IS_FETCHING_DATA: '@@checkout/UPDATE_IS_FETCHING_DATA',
};
export const AccordionStepsActionTypes = {
    NAVIGATE_STEP: '@@accordion/NAVIGATE_STEP',
};
export const StoreLocatorActionTypes = {
    FETCH_STORES: '@@storelocator/FETCH_STORES',
    FETCH_STORE_DETAILS: '@@storelocator/FETCH_STORE_DETAILS',
    UPDATE_BOUNDS: '@@storelocator/UPDATE_BOUNDS',
    USE_LOCATION: '@@storelocator/USE_LOCATION',
};
